import clientComponents from '@/components/client-components'
import { differenceInDays } from 'date-fns'

export async function canAskQuestions({
  sessionStatus,
  subdomain
}: {
  sessionStatus: 'authenticated' | 'unauthenticated' | 'loading'
  subdomain: string
}) {
  if (sessionStatus === 'authenticated') {
    return true
  }

  const { loginRequired } =
    clientComponents[subdomain] || clientComponents.default
  if (!loginRequired) {
    return true
  }

  const questionCount = localStorage.getItem('question-count')
  const questionDate = localStorage.getItem('question-date')

  const newQuestionCount = questionCount ? Number(questionCount) + 1 : 1
  const diffDays = questionDate
    ? differenceInDays(new Date(), new Date(questionDate))
    : 0

  if (diffDays > 0) {
    await localStorage.setItem('question-count', '1')
    await localStorage.setItem('question-date', new Date().toISOString())
  } else {
    await localStorage.setItem('question-count', newQuestionCount.toString())
    await localStorage.setItem('question-date', new Date().toISOString())
  }

  return (diffDays === 0 && newQuestionCount < 3) || diffDays > 0
}
